// extracted by mini-css-extract-plugin
export default {"table":"general_table__cVI+P","table__heading":"general_table__heading__-+pnk","table__cell":"general_table__cell__ESGnz","table__badge":"general_table__badge__hz2X8"};